import LiquidText from './LiquidText';
import { LiquidDialog } from './LiquidUI';
import DeleteIcon from './DeleteIcon';
import React, { useState } from 'react';
import api from '../services/api';
import { abrirFicheiroDaResposta } from '../utils/abrirFicheiro';

/* ============================================================
   ANEXOS DE REGISTOS DO SGI — auditorias, revisões pela gestão
   e ações de formação.

   Os três registos guardavam a evidência como uma referência de
   texto para um caminho de rede. Um relatório de auditoria que só
   existe no J: não prova nada dentro da aplicação. As rotas são
   iguais nos três casos, muda só o segmento inicial.
   ============================================================ */

const fmtData = (d) => { if (!d) return ''; try { return new Date(d).toLocaleDateString('pt-PT'); } catch { return ''; } };

export default function AnexosSgiModal({ rota, registo, etiqueta, onClose, onMudou }) {
    const [anexos, setAnexos] = useState(registo.anexos || []);
    const [titulo, setTitulo] = useState('');
    const [data, setData] = useState('');
    const [ficheiro, setFicheiro] = useState(null);
    const [erro, setErro] = useState('');
    const [ocupado, setOcupado] = useState(false);

    const carregar = async () => {
        if (!ficheiro) { setErro('Escolha um ficheiro.'); return; }
        setOcupado(true); setErro('');
        const fd = new FormData();
        fd.append('ficheiro', ficheiro);
        fd.append('titulo', titulo.trim() || ficheiro.name);
        if (data) fd.append('data_documento', data);
        try {
            const r = await api.post(`/sistema-integrado/${rota}/${registo.id}/anexos`, fd,
                { headers: { 'Content-Type': 'multipart/form-data' } });
            setAnexos(prev => [...prev, r.data]);
            setTitulo(''); setData(''); setFicheiro(null);
            onMudou();
        } catch (e) { setErro(e.response?.data?.error || 'Erro ao carregar'); }
        finally { setOcupado(false); }
    };

    /* O endpoint exige token, por isso o ficheiro vem como blob e abre-se a
       partir de um object URL — um window.open direto devolvia 401. */
    const abrir = async (a) => {
        try {
            const r = await api.get(`/sistema-integrado/${rota}/anexos/${a.id}/ficheiro`, { responseType: 'blob' });
            abrirFicheiroDaResposta(r, a.nome_original || '');
        } catch { alert('Erro ao abrir o ficheiro.'); }
    };

    const remover = async (a) => {
        if (!window.confirm(`Eliminar "${a.titulo}"?`)) return;
        try {
            await api.delete(`/sistema-integrado/${rota}/anexos/${a.id}`);
            setAnexos(prev => prev.filter(x => x.id !== a.id));
            onMudou();
        } catch { alert('Erro ao eliminar.'); }
    };

    return (
        <LiquidDialog data-sgi-dialog="true" onClose={onClose} style={overlay} onClick={onClose}>
            <div style={{ ...modal, maxWidth: 640 }} onClick={e => e.stopPropagation()}>
                <div data-sgi-dialog-heading="true" style={modalHead}>
                    <h3 style={{ margin: 0 }}>Anexos — {etiqueta}</h3>
                    <button data-liquid-close="true" aria-label="Fechar" onClick={onClose} style={closeBtn}><LiquidText>✕</LiquidText></button>
                </div>

                {anexos.length === 0
                    ? <p style={{ color: '#94a3b8', fontSize: '0.86rem' }}>Sem anexos.</p>
                    : (
                        <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, marginBottom: 14 }}>
                            {anexos.map(a => (
                                <div data-liquid-actions="true" key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', borderBottom: '1px solid #f8fafc' }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontWeight: 600, fontSize: '0.86rem' }}><LiquidText>{a.titulo}</LiquidText></div>
                                        <div style={{ color: '#94a3b8', fontSize: '0.75rem' }}>
                                            {a.nome_original}{a.data_documento ? ` · ${fmtData(a.data_documento)}` : ''}
                                            {a.tamanho ? ` · ${Math.round(a.tamanho / 1024)} KB` : ''}
                                        </div>
                                        {a.observacoes && (
                                            <div style={{ color: '#64748b', fontSize: '0.75rem', marginTop: 3 }}>{a.observacoes}</div>
                                        )}
                                    </div>
                                    <button data-liquid-secondary="true" onClick={() => abrir(a)} style={{ ...btnSec, ...mini }}>Abrir</button>
                                    <button data-liquid-secondary="true" onClick={() => remover(a)} style={{ ...btnSec, ...mini, color: '#e53e3e' }} aria-label="Apagar" title="Apagar"><DeleteIcon /></button>
                                </div>
                            ))}
                        </div>
                    )}

                <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 12 }}>
                    <div data-liquid-grid="true" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                        <div>
                            <label data-liquid-label="true" style={lbl}>Título</label>
                            <input value={titulo} onChange={e => setTitulo(e.target.value)}
                                placeholder="por omissão, o nome do ficheiro" style={{ ...inp, width: '100%' }} />
                        </div>
                        <div>
                            <label data-liquid-label="true" style={lbl}>Data do documento</label>
                            <input type="date" value={data} onChange={e => setData(e.target.value)} style={{ ...inp, width: '100%' }} />
                        </div>
                    </div>
                    <input type="file" onChange={e => setFicheiro(e.target.files?.[0] || null)} style={{ marginBottom: 10 }} />
                    {erro && <div style={{ color: '#e53e3e', fontSize: '0.84rem', marginBottom: 8 }}>{erro}</div>}
                    <div data-liquid-actions="true" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <button data-liquid-secondary="true" onClick={onClose} style={btnSec}>Fechar</button>
                        <button data-liquid-primary="true" onClick={carregar} disabled={ocupado} style={{ ...btnPri, opacity: ocupado ? 0.6 : 1 }}>
                            {ocupado ? 'A carregar…' : '+ Carregar'}
                        </button>
                    </div>
                </div>
            </div>
        </LiquidDialog>
    );
}

const lbl = { display: 'block', fontSize: '0.74rem', color: '#64748b', fontWeight: 600, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.03em' };
const inp = { padding: '7px 10px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: '0.9rem', boxSizing: 'border-box' };
const btnSec = { padding: '7px 14px', border: '1px solid #cbd5e1', background: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem', color: '#334155' };
const btnPri = { padding: '7px 14px', border: '1px solid #3182ce', background: '#3182ce', color: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem' };
const mini = { padding: '4px 9px', marginLeft: 6, fontSize: '0.76rem' };
const overlay = { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, padding: '40px 16px', overflowY: 'auto' };
const modal = { background: '#fff', borderRadius: 14, padding: 22, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' };
const modalHead = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 };
const closeBtn = { border: 'none', background: 'transparent', fontSize: '1.2rem', cursor: 'pointer', color: '#64748b' };
